import { Checked, Unchecked, Error } from 'ui/icons';
import { CampaignStep } from '../../types';

export const CheckmarkCircleTestId = (campaignStep: CampaignStep, isComplete: boolean) =>
  `${isComplete ? 'complete' : 'incomplete'}-step-${campaignStep}`;

export const validationCircleTestId = (campaignStep: CampaignStep) =>
  `invalid-step-${campaignStep}`;

const size = { width: 32, height: 32 };

export const CheckmarkCircle = ({
  isComplete,
  campaignStep,
}: {
  isComplete?: boolean;
  campaignStep: CampaignStep;
}) => {
  const CheckedIcon = isComplete ? Checked : Unchecked;
  return (
    <>
      <CheckedIcon
        {...size}
        data-test={CheckmarkCircleTestId(campaignStep, isComplete as boolean)}
      />
    </>
  );
};

export const ValidationCircle = ({ campaignStep }: { campaignStep: CampaignStep }) => (
  <Error {...size} data-test={validationCircleTestId(campaignStep)} />
);
